import { render, staticRenderFns } from "./ReassignPromoterDialog.component.vue?vue&type=template&id=caab887a&scoped=true"
import script from "./ReassignPromoterDialog.component.vue?vue&type=script&lang=ts"
export * from "./ReassignPromoterDialog.component.vue?vue&type=script&lang=ts"
import style0 from "./ReassignPromoterDialog.component.vue?vue&type=style&index=0&id=caab887a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caab887a",
  null
  
)

export default component.exports